import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import Container from '../Container'
import HighlightText from '../HighlightText'
import SecuritySvg from '../Icons/SecuritySvg'
import NumberSvg from '../Icons/NumberSvg'
import SceneSvg from '../Icons/SceneSvg'
import { picUrl } from '@/common/utils/consts'

const Solution = () => {
  const { t } = useTranslation()

  const diningCards = [
    {
      image: <NumberSvg />,
      title: t('ent_o_solution_digital_flexibility', '数字化与灵活性驱动'),
      description: t('ent_o_solution_scenario_support', '支持多种餐饮津贴场景，满足客户灵活性需求'),
    },
    {
      image: <SecuritySvg />,
      title: t('ent_o_solution_compliance_security', '合规性与安全性保证'),
      description: t('ent_o_solution_data_security', '数据安全，提供符合税务和财务合规的解决方案'),
      style: { paddingTop: '5.6rem', paddingBottom: '5.6rem' },
    },
    {
      image: <SceneSvg />,
      title: t('ent_o_solution_innovation_ecology', '场景创新与生态协同'),
      description: t('ent_o_solution_open_capability', '拥有开放能力，提高企业数智化水平'),
    },
  ]

  return (
    <Container gray>
      <div className={styles.container}>
        {/* 标题区域 */}
        <div className={styles.titleWrapper}>
          <h2 className="section-title">
            <HighlightText>{t('ent_o_title_ai_empowerment1', 'AI赋能')}</HighlightText>
            <span>
              {t('ent_o_title_catering_solution1', '的企业餐饮津贴解决方案')}
            </span>
          </h2>
          <div className={styles.sectionDes}>
            {t('ent_o_solution_resource_integration', '整合区域餐饮及配送资源，布局全港，为不同规模企业提供高性价比、高定制化的餐饮津贴解决方案')}
          </div>
        </div>

        <div className={styles.cardContainer}>
          <div className={`${styles.cardGrid} ${styles.cardAnimation}`}>
            {diningCards.map(item => (
              <div className={styles.card} style={item.style}>
                <div className={styles.iconWrapper} aria-hidden="true">
                  {item.image}
                </div>
                <div className={styles.content}>
                  <h3 className={styles.title}>
                    {item.title}
                  </h3>
                  <p className={styles.description}>
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.desImgWraper}>
            <div  className={styles.desImg} style={{ backgroundImage: `url(${picUrl.ai})` }} />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Solution